// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../node_modules/css-loader/dist/cjs.js!./global.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Mounted as a child inside pipeline-sandbox's own view container (a flex
   column) — fill it, rather than rendering our own fixed-position overlay.
   Reuses .ps-detail-header/.btn/.ps-input from pipeline-sandbox.css and
   .mlw-placeholder/.mlw-error-row/.mlw-param-label/.mlw-preview-status from
   ml-panel-shared.css — this file only adds the queue/detail layout. */
:host {
    display: flex;
    flex-direction: column;
    flex: 1;
    min-height: 0;
    overflow: hidden;
}

.mll-filter-toggle {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 12px;
    margin-left: 12px;
}

.mll-layout {
    flex: 1;
    display: flex;
    overflow: hidden;
}

.mll-list {
    width: 360px;
    flex-shrink: 0;
    overflow-y: auto;
    border-right: 1px solid var(--border-color, #e0e0e0);
}

.mll-row {
    padding: 10px 14px;
    border-bottom: 1px solid var(--border-color, #eee);
    cursor: pointer;
    font-size: 12px;
}

.mll-row:hover {
    background: var(--bg-hover, #f5f5f5);
}

.mll-row.mll-row-selected {
    background: rgba(0, 102, 204, 0.08);
}

.mll-row-entity {
    font-weight: 600;
}

.mll-row-model {
    color: var(--text-secondary, #666);
    font-size: 11px;
}

.mll-row-meta {
    display: flex;
    justify-content: space-between;
    margin-top: 4px;
    font-size: 11px;
    color: var(--text-secondary, #777);
}

.mll-label-badge {
    display: inline-block;
    padding: 1px 7px;
    border-radius: 10px;
    font-size: 10px;
    font-weight: 600;
    text-transform: uppercase;
}

.mll-label-badge.pending { background: #fff3cd; color: #856404; }
.mll-label-badge.yes { background: #d4edda; color: #155724; }
.mll-label-badge.no { background: #f8d7da; color: #721c24; }

.mll-detail {
    flex: 1;
    min-width: 0;
    overflow-y: auto;
    padding: 16px 20px;
}

.mll-detail-header {
    font-size: 15px;
    font-weight: 600;
    margin-bottom: 10px;
}

.mll-kv-row {
    display: flex;
    justify-content: space-between;
    gap: 12px;
    font-size: 12px;
    padding: 3px 0;
    border-bottom: 1px solid var(--border-color, #f0f0f0);
}

.mll-context {
    margin-top: 14px;
}

.mll-context pre {
    background: #f5f5f5;
    padding: 10px;
    border-radius: 4px;
    font-size: 11px;
    max-height: 320px;
    overflow: auto;
}

.mll-actions-row {
    display: flex;
    gap: 8px;
    margin-top: 16px;
}

.mll-datasets {
    margin-top: 24px;
    border-top: 1px solid var(--border-color, #e0e0e0);
    padding-top: 14px;
}

.mll-dataset-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 12px;
    padding: 4px 0;
}
`, "",{"version":3,"sources":["webpack://./src/ml-labeling.css"],"names":[],"mappings":"AAEA;;;;uEAIuE;AACvE;IACI,aAAa;IACb,sBAAsB;IACtB,OAAO;IACP,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,OAAO;IACP,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,cAAc;IACd,gBAAgB;IAChB,oDAAoD;AACxD;;AAEA;IACI,kBAAkB;IAClB,kDAAkD;IAClD,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kCAAkC;IAClC,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,eAAe;IACf,eAAe;IACf,kCAAkC;AACtC;;AAEA;IACI,qBAAqB;IACrB,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA,2BAA2B,mBAAmB,EAAE,cAAc,EAAE;AAChE,uBAAuB,mBAAmB,EAAE,cAAc,EAAE;AAC5D,sBAAsB,mBAAmB,EAAE,cAAc,EAAE;;AAE3D;IACI,OAAO;IACP,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,eAAe;IACf,cAAc;IACd,qDAAqD;AACzD;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,kDAAkD;IAClD,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,eAAe;IACf,cAAc;AAClB","sourcesContent":["@import url(\"./global.css\");\n\n/* Mounted as a child inside pipeline-sandbox's own view container (a flex\n   column) — fill it, rather than rendering our own fixed-position overlay.\n   Reuses .ps-detail-header/.btn/.ps-input from pipeline-sandbox.css and\n   .mlw-placeholder/.mlw-error-row/.mlw-param-label/.mlw-preview-status from\n   ml-panel-shared.css — this file only adds the queue/detail layout. */\n:host {\n    display: flex;\n    flex-direction: column;\n    flex: 1;\n    min-height: 0;\n    overflow: hidden;\n}\n\n.mll-filter-toggle {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    font-size: 12px;\n    margin-left: 12px;\n}\n\n.mll-layout {\n    flex: 1;\n    display: flex;\n    overflow: hidden;\n}\n\n.mll-list {\n    width: 360px;\n    flex-shrink: 0;\n    overflow-y: auto;\n    border-right: 1px solid var(--border-color, #e0e0e0);\n}\n\n.mll-row {\n    padding: 10px 14px;\n    border-bottom: 1px solid var(--border-color, #eee);\n    cursor: pointer;\n    font-size: 12px;\n}\n\n.mll-row:hover {\n    background: var(--bg-hover, #f5f5f5);\n}\n\n.mll-row.mll-row-selected {\n    background: rgba(0, 102, 204, 0.08);\n}\n\n.mll-row-entity {\n    font-weight: 600;\n}\n\n.mll-row-model {\n    color: var(--text-secondary, #666);\n    font-size: 11px;\n}\n\n.mll-row-meta {\n    display: flex;\n    justify-content: space-between;\n    margin-top: 4px;\n    font-size: 11px;\n    color: var(--text-secondary, #777);\n}\n\n.mll-label-badge {\n    display: inline-block;\n    padding: 1px 7px;\n    border-radius: 10px;\n    font-size: 10px;\n    font-weight: 600;\n    text-transform: uppercase;\n}\n\n.mll-label-badge.pending { background: #fff3cd; color: #856404; }\n.mll-label-badge.yes { background: #d4edda; color: #155724; }\n.mll-label-badge.no { background: #f8d7da; color: #721c24; }\n\n.mll-detail {\n    flex: 1;\n    min-width: 0;\n    overflow-y: auto;\n    padding: 16px 20px;\n}\n\n.mll-detail-header {\n    font-size: 15px;\n    font-weight: 600;\n    margin-bottom: 10px;\n}\n\n.mll-kv-row {\n    display: flex;\n    justify-content: space-between;\n    gap: 12px;\n    font-size: 12px;\n    padding: 3px 0;\n    border-bottom: 1px solid var(--border-color, #f0f0f0);\n}\n\n.mll-context {\n    margin-top: 14px;\n}\n\n.mll-context pre {\n    background: #f5f5f5;\n    padding: 10px;\n    border-radius: 4px;\n    font-size: 11px;\n    max-height: 320px;\n    overflow: auto;\n}\n\n.mll-actions-row {\n    display: flex;\n    gap: 8px;\n    margin-top: 16px;\n}\n\n.mll-datasets {\n    margin-top: 24px;\n    border-top: 1px solid var(--border-color, #e0e0e0);\n    padding-top: 14px;\n}\n\n.mll-dataset-row {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    font-size: 12px;\n    padding: 4px 0;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
